import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IconButton } from 'material-ui';
import Delete from 'material-ui/svg-icons/action/delete';
import { StyleSheet, css } from 'aphrodite';

import * as InquiryActions from '../../store/actions/InquiryActions';
import { dateString } from '../../util/dates';

@connect()
export default class SegmentListItem extends React.Component {
  static propTypes = {
    index: PropTypes.number.isRequired,
    segment: PropTypes.shape().isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  remove = () => {
    const { dispatch, index } = this.props;
    dispatch(InquiryActions.removeSegment(index));
  }

  render() {
    const { segment: { vendor, startDate, endDate } } = this.props;
    const datestring = startDate && endDate ? dateString(startDate, endDate) : '';

    return (<li className={css(styles.listItem)}>
      <div>{vendor || 'TBD'} {datestring}</div>
      <div>
        <IconButton className={css(styles.buttonStyle)} onTouchTap={this.remove}>
          <Delete />
        </IconButton>
      </div>
    </li>);
  }
}

const styles = StyleSheet.create({
  listItem: {
    width: 300,
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
  },
  buttonStyle: {
    height: 24,
    width: 24,
    padding: 0,
    position: 'relative',
    top: 5,
    marginRight: 5,
  },
});



// WEBPACK FOOTER //
// /src/components/Inquiry/SegmentListItem.js